import React from "react";
import moment from "moment";

import {
  fetchWeeklyAdoptionMatrix,
  fetchWeeklyAdoptionTimelineC1,
  fetchWeeklyAdoptionTimelineC2,
  fetchWeeklyAdoptionTimelineC3,
  fetchWeeklyAdoptionTimelineC4,
  fetchWeeklyAdoptionList,
} from "actions/adoptionMetrics";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Grid, Icon, Modal, Visibility } from "semantic-ui-react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

import _, { isNumber, set } from "lodash";
import cx from "classnames";

import styles from "./weekly.module.scss";
import { useState } from "react";
import { Waypoint } from "react-waypoint";
import Download from "components/ui/Download";

function WeeklyAdoption() {
  const dispatch = useDispatch();

  const to = moment()
    .subtract(1, "days")
    .format("YYYY-MM-DD");

  const lastTwoWeek = moment()
    .subtract(7, "days")
    .format("YYYY-MM-DD");

  useEffect(() => {
    dispatch(fetchWeeklyAdoptionMatrix({ from: to, to: to }));
    dispatch(fetchWeeklyAdoptionTimelineC1({ from: lastTwoWeek, to: to }));
    dispatch(fetchWeeklyAdoptionTimelineC2({ from: lastTwoWeek, to: to }));
    dispatch(fetchWeeklyAdoptionTimelineC3({ from: lastTwoWeek, to: to }));
    dispatch(fetchWeeklyAdoptionTimelineC4({ from: lastTwoWeek, to: to }));
  }, []);

  return (
    <>
      <div className={styles.weeklyAdoption}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={10}>
              <AdoptionTimeline />
            </Grid.Column>
            <Grid.Column width={6}>
              <AdoptionMatrix from={lastTwoWeek} to={to} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </>
  );
}

function AdoptionTimelineToolTip({ tooltip, active, payload }) {
  if (active && !_.isEmpty(payload)) {
    var item = payload[0].payload;

    return (
      <div className={styles.tooltipBox}>
        <div className={styles.tooltipText}>{item.text}</div>
        <div>
          <div className={styles.tooltipSubText}> AT RISK</div>
          <div className={styles.tooltipValue1}>
            {" "}
            {item.timelineC1 ? item.timelineC1 : 0}{" "}
          </div>
        </div>
        <div>
          <div className={styles.tooltipSubText}>WATCH</div>
          <div className={styles.tooltipValue2}>
            {" "}
            {item.timelineC2 ? item.timelineC2 : 0}
          </div>
        </div>
        <div>
          <div className={styles.tooltipSubText}>GOOD</div>
          <div className={styles.tooltipValue3}>
            {item.timelineC3 ? item.timelineC3 : 0}{" "}
          </div>
        </div>
        <div>
          <div className={styles.tooltipSubText}>HIGH</div>
          <div className={styles.tooltipValue4}>
            {" "}
            {item.timelineC4 ? item.timelineC4 : 0}
          </div>
        </div>
      </div>
    );
  }

  return <>tooltip</>;
}

function AdoptionTimeline() {
  const timelineC1Items = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.timelineC1.items", [])
  );

  const timelineC2Items = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.timelineC2.items", [])
  );

  const timelineC3Items = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.timelineC3.items", [])
  );

  const timelineC4Items = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.timelineC4.items", [])
  );

  var timeline = [];
  if (!_.isEmpty(timelineC1Items)) {
    for (var item of timelineC1Items) {
      var text = moment(item.date).format("DD-MMM-YY");
      var value = item.value;

      if (_.isEmpty(timeline)) {
        timeline.push({ text: text, timelineC1: value });
        continue;
      }

      const existing = timeline.find((element) => element.text === text);
      if (existing === null || existing === undefined) {
        timeline.push({ text: text, timelineC1: value });
        continue;
      }

      existing["timelineC1"] = value;
    }
  }

  if (!_.isEmpty(timelineC2Items)) {
    for (var item of timelineC2Items) {
      var text = moment(item.date).format("DD-MMM-YY");
      var value = item.value;

      if (_.isEmpty(timeline)) {
        timeline.push({ text: text, timelineC2: value });
        continue;
      }

      const existing = timeline.find((element) => element.text === text);
      if (existing === null || existing === undefined) {
        timeline.push({ text: text, timelineC2: value });
        continue;
      }

      existing["timelineC2"] = value;
    }
  }

  if (!_.isEmpty(timelineC3Items)) {
    for (var item of timelineC3Items) {
      var text = moment(item.date).format("DD-MMM-YY");
      var value = item.value;

      if (_.isEmpty(timeline)) {
        timeline.push({ text: text, timelineC3: value });
        continue;
      }

      const existing = timeline.find((element) => element.text === text);
      if (existing === null || existing === undefined) {
        timeline.push({ text: text, timelineC3: value });
        continue;
      }

      existing["timelineC3"] = value;
    }
  }

  if (!_.isEmpty(timelineC4Items)) {
    for (var item of timelineC4Items) {
      var text = moment(item.date).format("DD-MMM-YY");
      var value = item.value;

      if (_.isEmpty(timeline)) {
        timeline.push({ text: text, timelineC4: value });
        continue;
      }

      const existing = timeline.find((element) => element.text === text);
      if (existing === null || existing === undefined) {
        timeline.push({ text: text, timelineC4: value });
        continue;
      }

      existing["timelineC4"] = value;
    }
  }

  return (
    <div className={styles.timeline}>
      <div className={styles.adoptionTitle}>Weekly Adoption</div>
      <ResponsiveContainer width={"100%"} height={300}>
        <LineChart width={500} height={300} data={timeline}>
          <XAxis
            dataKey="text"
            allowDuplicatedCategory={true}
            axisLine={false}
            tick={true}
          />
          <YAxis axisLine={false} />
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <Line
            type="natural"
            dataKey="timelineC1"
            stroke="#DB003C"
            strokeWidth={2.5}
            dot={false}
          />
          <Line
            type="natural"
            dataKey="timelineC2"
            stroke="#F06000"
            strokeWidth={2.5}
            dot={false}
          />
          <Line
            type="natural"
            dataKey="timelineC3"
            stroke="#D9AD0B"
            strokeWidth={2.5}
            dot={false}
          />
          <Line
            type="natural"
            dataKey="timelineC4"
            stroke="#619D0C"
            strokeWidth={2.5}
            dot={false}
          />

          <Tooltip
            wrapperStyle={{ outlineColor: "#E50C58" }}
            content={<AdoptionTimelineToolTip />}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

function AdoptionMatrix({ from, to }) {
  const dispatch = useDispatch();

  const [category, setCategory] = useState(null);

  const [open, setOpen] = useState(false);

  const matrix = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.matrix.items", [])
  );

  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);

  const downloads = useSelector((state) => _.get(state, "downloads", {}));

  useEffect(() => {
    if (downloads.downloaded) {
      var headers = ["Id", "Name"];
      var data = [];

      var items = downloads.items;
      if (items && items.length > 0) {
        var item = items[0];

        if (item.adoptions && item.adoptions.length > 0) {
          item.adoptions.map((adoption, index) => {
            let date = adoption.date;
            headers.push(date + " (Total)");
            headers.push(date + " (Enabled)");
            headers.push(date + " (Active)");
            headers.push(date + " (Adoption)");
          });
        }

        items.map((item, index) => {
          var row = [];

          row.push(item.id);
          row.push(item.name);

          if (item.adoptions && item.adoptions.length > 0) {
            item.adoptions.map((adoption, index) => {
              row.push(adoption.total);
              row.push(adoption.enabled);
              row.push(adoption.active);
              row.push(adoption.adoption);
            });
          }

          data.push(row);
        });
      }

      setHeaders(headers);
      setData(data);
    }
  }, [downloads]);

  var adotionC1 = 0,
    adotionC2 = 0,
    adotionC3 = 0,
    adotionC4 = 0;

  if (!_.isEmpty(matrix)) {
    for (var item of matrix) {
      if (item.text === "CATEGORY_0_25") {
        adotionC1 = item.value;
      } else if (item.text === "CATEGORY_25_50") {
        adotionC2 = item.value;
      } else if (item.text === "CATEGORY_50_75") {
        adotionC3 = item.value;
      } else if (item.text === "CATEGORY_75_100") {
        adotionC4 = item.value;
      }
    }
  }

  const viewAdoptionList = (selected) => {
    setOpen(true);
    setCategory(selected);
  };

  const downloadTo = moment()
    .subtract(1, "days")
    .format("YYYY-MM-DD");

  const downloadFrom = moment()
    .subtract(1, "months")
    .format("YYYY-MM-DD");

  var downloadRequest = {
    type: "WEEKLY",
    fromDate: downloadFrom,
    toDate: downloadTo,
  };

  return (
    <div className={styles.matrix}>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column>
            <div className={styles.matrixTitle}>Adoption Matrix</div>
          </Grid.Column>
          <Grid.Column>
            <Download
              id="adoption_report"
              name="AdoptionReport"
              request={downloadRequest}
              headers={headers}
              data={data}
              url="api/1.0/metrics/adoption/download"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <div className={styles.matrixCard}>
              <div className={styles.matrixLabel}>
                <div className={styles.matrixLabelText}>0% - 25%</div>
                <div className={styles.matrixLabelIcon}>
                  <Icon
                    name="eye"
                    onClick={() => viewAdoptionList("CATEGORY_0_25")}
                  />
                </div>
              </div>
              <div className={styles.matrixPct}>
                <div className={styles.matrixPct1}> {adotionC1} </div>
                <div className={styles.matrixPctText}> AT RISK </div>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className={styles.matrixCard}>
              <div className={styles.matrixLabel}>
                <div className={styles.matrixLabelText}>25% - 50%</div>
                <div className={styles.matrixLabelIcon}>
                  <Icon
                    name="eye"
                    onClick={() => viewAdoptionList("CATEGORY_25_50")}
                  />
                </div>
              </div>
              <div className={styles.matrixPct}>
                <div className={styles.matrixPct2}>{adotionC2} </div>
                <div className={styles.matrixPctText}> WATCH </div>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <div className={styles.matrixCard}>
              <div className={styles.matrixLabel}>
                <div className={styles.matrixLabelText}>50% - 75%</div>
                <div className={styles.matrixLabelIcon}>
                  <Icon
                    name="eye"
                    onClick={() => viewAdoptionList("CATEGORY_50_75")}
                  />
                </div>
              </div>
              <div className={styles.matrixPct}>
                <div className={styles.matrixPct3}>{adotionC3} </div>
                <div className={styles.matrixPctText}> GOOD </div>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className={styles.matrixCard}>
              <div className={styles.matrixLabel}>
                <div className={styles.matrixLabelText}>75% - 100%</div>
                <div className={styles.matrixLabelIcon}>
                  <Icon
                    name="eye"
                    onClick={() => viewAdoptionList("CATEGORY_75_100")}
                  />
                </div>
              </div>
              <div className={styles.matrixPct}>
                <div className={styles.matrixPct4}>{adotionC4} </div>
                <div className={styles.matrixPctText}> HIGH </div>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <AdoptionList open={open} setOpen={setOpen} category={category} />
    </div>
  );
}

function AdoptionList({ open, setOpen, category }) {
  const list = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.list", [])
  );

  const formatPercentage = (percentage) => {
    if (percentage % 1 !== 0) {
      return percentage.toFixed(1);
    }

    return percentage;
  };

  const renderItems = () => {
    if (_.isEmpty(list) || _.isEmpty(list.items)) {
      return [];
    }

    var items = list.items.map((item, index) => (
      <>
        <Grid.Row columns={4}>
          <Grid.Column width={6}>{item.name}</Grid.Column>
          <Grid.Column width={3}>
            <div style={{ textAlign: "center" }}>{item.activeUsers} </div>
          </Grid.Column>
          <Grid.Column width={3}>
            <div style={{ textAlign: "center" }}>{item.weeklyActiveUsers} </div>
          </Grid.Column>
          <Grid.Column width={4}>
            <div style={{ textAlign: "center" }}>
              {formatPercentage(item.weeklyAdoptionPct)}%
            </div>
          </Grid.Column>
        </Grid.Row>
      </>
    ));

    return <Grid> {items} </Grid>;
  };

  const date = moment()
    .subtract(1, "days")
    .format("YYYY-MM-DD");

  return (
    <>
      <Modal
        centered
        size="tiny"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
      >
        <Modal.Content>
          <Grid>
            <Grid.Row columns={4}>
              <Grid.Column width={6} textAlign="center">
                <div style={{ fontSize: "12px", fontWeight: "normal" }}>
                  NAME
                </div>
              </Grid.Column>
              <Grid.Column width={3} textAlign="center">
                <div style={{ fontSize: "12px", fontWeight: "normal" }}>
                  USERS
                </div>
              </Grid.Column>
              <Grid.Column width={3} textAlign="center">
                <div style={{ fontSize: "12px", fontWeight: "normal" }}>
                  WAU
                </div>
              </Grid.Column>
              <Grid.Column width={4} textAlign="center">
                <div style={{ fontSize: "12px", fontWeight: "normal" }}>
                  ADOPTION %
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <InfiniteScroll category={category} from={date} to={date}>
            {renderItems()}
          </InfiniteScroll>
        </Modal.Content>
      </Modal>
    </>
  );
}

function InfiniteScroll({ children, category, from, to }) {
  const dispatch = useDispatch();

  const currentPage = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.list.pagination.currentPage")
  );

  const loading = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.list.loading")
  );

  const totalPages = useSelector((state) =>
    _.get(state, "adoptionMetrics.weeklyAdoption.list.pagination.totalPages")
  );

  useEffect(() => {
    fetchItems(0);
  }, []);

  const fetchItems = (page) => {
    if (!loading) {
      dispatch(
        fetchWeeklyAdoptionList({
          category: category,
          from: from,
          to: to,
          page: page,
          limit: 10,
        })
      );
    }
  };

  const loadMoreData = () => {
    if (isNumber(currentPage)) {
      const nextPage = currentPage + 1;
      const totalPage = totalPages;

      if (nextPage < totalPage) {
        fetchItems(nextPage);
      }
    }
  };

  return (
    <>
      <div
        style={{
          height: "350px",
          marginTop: "15px",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        {children}
        <Waypoint onEnter={loadMoreData}></Waypoint>
      </div>
    </>
  );
}

export default WeeklyAdoption;
